import { useMutation } from 'react-query';

import { axios } from '@/lib/axios';

type UpdateCrossingRequestedDateType = {
  folderId: string;
};

const deletePreFolderAsync = ({ folderId }: UpdateCrossingRequestedDateType) =>
  axios.delete(`/pre-folders/${folderId}`);

export const useDeletePreFolderAsync = () =>
  useMutation({
    mutationFn: deletePreFolderAsync,
  });
